import React from 'react'

import { ChevronRightIcon } from '@toasttab/buffet-pui-icons'
import UserIcon from './UserIcon'

import Link from 'shared/components/common/link'
import Image from 'shared/components/common/Image'
import { isValidAccountPath } from 'shared/components/common/restaurant_routes/RestaurantRoutesContext'
import { t } from 'src/translations'
import { Button } from 'shared/components/common/button'
import { ButtonType } from 'src/apollo/sites'
import { ModalCloseButton } from 'shared/components/common/modal'

import { useCustomer } from 'public/components/online_ordering/CustomerContextCommon'

type AccountDropdownProps = {
  accountPath: string
  onLogout: () => void
  showMobileHeader?: boolean
  onClose?: () => void
}

const AccountDropdown = ({
  accountPath,
  onLogout,
  showMobileHeader = false,
  onClose
}: AccountDropdownProps) => {
  const { customer } = useCustomer()

  if (!customer) {
    return null
  }

  const firstName = customer.firstName || ''
  const lastName = customer.lastName || ''
  const fullName = `${firstName} ${lastName}`.trim()
  const email = customer.email || ''

  return (
    <div className='accountDropdown'>
      {showMobileHeader && (
        <>
          <div className='modalHeader'>
            <h2>{t('account-dropdown.account')}</h2>
            {onClose && <ModalCloseButton onClose={onClose} />}
          </div>
          <div className='divider' />
        </>
      )}
      <div className='userInfo'>
        <div className='userDetails'>
          <div className='name'>{fullName}</div>
          <div className='email'>{email}</div>
        </div>
        <Image
          src='icons/toast-logo-filled.svg'
          alt='Toast logo'
          aria-hidden='true'
        />
      </div>

      {isValidAccountPath(accountPath) && (
        <div>
          <div className='divider' />

          <Link href={accountPath} className='settings'>
            <div className='settingsIcon'>
              <UserIcon
                aria-label={'Account settings'}
                color={'currentColor'}
              />
            </div>
            <div className='settingsContent'>
              <div className='settingsTitle'>
                {t('account-dropdown.account-details')}
              </div>
              <div className='settingsSubtitle'>
                {t('account-dropdown.information-and-preferences')}
              </div>
            </div>
            <div className='chevron'>
              <ChevronRightIcon />
            </div>
          </Link>
          <div className='divider' />
        </div>
      )}
      <div className='logoutButton'>
        <Button
          className='logout'
          variant={ButtonType.Secondary}
          onClick={onLogout}
          testId='account-dropdown-logout'
          aria-haspopup='dialog'
        >
          {t('account-dropdown.log-out')}
        </Button>
      </div>
    </div>
  )
}

export default AccountDropdown
